export default __webpack_public_path__ + "static/media/icon-phone.a4f2ed00.svg";